
import { defineComponent, PropType } from 'vue';
import { TileModel, TileLayoutOption } from '@/types/B2BcontentServerContract';
import usePersistedBlocks from '@/shared/content/blocks/helpers/usePersistedBlocks';

export default defineComponent({
    name: 'BlockList',
    props: {
        blocks: {
            type: Array as PropType<TileModel[]>,
            default: () => [],
        },
        // TODO: Remove fix later when EPi content tiles are refactored
        nested: {
            type: Boolean,
            required: false,
            default: false,
        },
        parent: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup() {
        const { getRenderKey } = usePersistedBlocks();
        const blockKey = (block: any, ix: number): string => {
            return getRenderKey(block.contentType, ix);
        };

        const halfWidthTile = (block: any): boolean => {
            return block.contentType === 'CallToActionTileModel' && block.model.layout === TileLayoutOption.HalfWidth;
        };

        return {
            blockKey,
            halfWidthTile,
        };
    },
});
